import { render, staticRenderFns } from "./DynamicFormDialog.vue?vue&type=template&id=66f827a9"
import script from "./DynamicFormDialog.vue?vue&type=script&lang=js"
export * from "./DynamicFormDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports